<template>
    <div id="ContainerSingleSignOns">
        <div class="page-height">
            <div class="col-12">
                <h4 v-if="this.$attrs.editMode" class="page-title text-truncate">
                    {{ $t('singleSignOns.Edit') }}
                </h4>
                <h4 v-if="!this.$attrs.editMode" class="page-title text-truncate">
                    {{ $t('singleSignOns.Add') }}
                </h4>

                <b-row>
                    <b-col lg="6" md="6" sm="12">
                        <MdLookup
                            v-bind:ModelCode="singleSignOnData.vendorCode"
                            v-bind:ModelDescription="singleSignOnData.vendorName"
                            v-bind:Label="$t('singleSignOnsList.Listing.eVendorName')"
                            v-bind:RefCode="'singleSignOnData.vendorCode'"
                            v-bind:Api="'Vendors'"
                            v-bind:Fields="availVendorsFields"
                            v-bind:FieldCode="'vendorcode'"
                            v-bind:FieldDescription="'name'"
                            v-bind:isRequired="true"
                            :SearchTitle="$t('singleSignOns.eAvailVendors')"
                            :GetValues="onAvailVendorCodeConditionOk"
                            :SearchFieldCode="'Code'"
                            v-bind:isValid="isVendorValid"
                            v-bind:IsDisabled="this.$attrs.editMode"
                            :InvalidFeedback="textVendorRequired"
                        />
                    </b-col>
                    <b-col lg="6" md="6" sm="12">
                        <MdLookup
                            v-bind:ModelCode="singleSignOnData.userId"
                            v-bind:ModelDescription="singleSignOnData.userName"
                            v-bind:Label="$t('singleSignOnsList.Listing.eUserName')"
                            v-bind:RefCode="'singleSignOnData.userId'"
                            v-bind:Api="'Users/LookUp'"
                            v-bind:Fields="availUsersFields"
                            v-bind:FieldCode="'code'"
                            v-bind:FieldDescription="'description'"
                            v-bind:isRequired="true"
                            :SearchTitle="$t('singleSignOns.eAvailUsers')"
                            :GetValues="onAvailUserCodeConditionOk"
                            :SearchFieldCode="'Code'"
                            v-bind:isValid="isUserValid"
                            v-bind:IsDisabled="this.$attrs.editMode"
                            :InvalidFeedback="textUserRequired"
                        />
                    </b-col>
                </b-row>

                <b-row>
                    <b-col lg="6" md="6" sm="12">
                        <MdEdit
                            v-model="singleSignOnData.otherUserId"
                            v-bind:Label="$t('singleSignOnsList.Listing.eUserID')"
                            v-bind:MaxLengthProp="45"
                        />
                    </b-col>
                    <b-col lg="6" md="6" sm="12">
                        <MdEdit
                            v-model="singleSignOnData.otherPassword"
                            v-bind:Label="$t('singleSignOnsList.Listing.ePassword')"
                            v-bind:MaxLengthProp="45"
                        />
                    </b-col>
                </b-row>

                <div class="space-actions"></div>
            </div>

            <div class="page-actions">
                <MdButton
                    v-bind:Label="$t('Shared.Back')"
                    v-bind:Name="'btn_single_sign_on_list'"
                    v-bind:ClassProp="'secondary mx-2 btn-login'"
                    v-on:click="DiscardChanges"
                />
                <MdButton
                    v-bind:Label="$t('Shared.Save')"
                    v-bind:ClassProp="
                        this.isReadOnlySingleSignOns ? 'primary mx-2' : 'primary btn-login mx-2'
                    "
                    v-on:click="SaveOrEdit"
                    v-bind:isReadOnly="isReadOnlySingleSignOns"
                    v-bind:Name="'btn_save_single_sign_on'"
                />
            </div>
        </div>
    </div>
</template>

<script>
import DBFunctions from '@/common/DBFunctions.js';
import ShowMessage from '@/components/messages/ShowMessage.js';
import SingleSignOnService from '@/services/singlesignon.service';
import { EventBus } from '../../../../event-bus.js';
import Permission from '@/common/Permission';

let elemSaveBtn = '';
export default {
    beforeRouteLeave(to, from, next) {
        if (this.pendingChanges) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
                    title: this.$t('Admission.Admission'),
                    okTitle: this.$t('Shared.BtnSave'),
                    cancelTitle: this.$t('Shared.BtnDismiss'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(async value => {
                    if (!value) {
                        next();
                    } else {
                        await this.SaveOrEdit();
                        next();
                    }
                });
        } else {
            next();
        }
    },

    name: 'SINGLESIGNONS',
    mixins: [ShowMessage, DBFunctions, Permission /*,EventBus*/],
    data() {
        return {
            textVendorRequired:this.$t('singleSignOns.eVendorRequired'),
            textUserRequired:this.$t('singleSignOns.eUserRequired'),

            parameter: {
                SearchCriteria: '',
                PageNumber: 1,
                PageSize: 0
            },
            pendingChanges: false,
            isVendorValid: null,
            isUserValid: null,

            singleSignOnData: {
                vendorCode: '',
                vendorName: '',
                userId: '',
                userName: '',
                otherPassword: '',
                otherUserId:'',
                recId: 0
            },
            availVendorsFields: [
                { key: 'vendorcode', sortable: true, label: this.$t('Shared.Code')},//, class: 'hidden'},
                { key: 'name', sortable: true, label: this.$t('Shared.Name') }
            ],
            availUsersFields: [
                { key: 'code', sortable: true, label: this.$t('Shared.Code')},//, class: 'hidden'},
                { key: 'description', sortable: true, label: this.$t('Shared.Name') }
            ],
            isReadOnlySingleSignOns: false,

            OptionsRightMenu: {
                visible: false,
                ItemsList: [],
                btnvisible: false,
                itemdisabled: false,
                PatientCode: '',
                Mode: this.edit_mode,
                favButtonAtion: false
            }
        };
    },

    methods: {
        //LookUp Available Vendors
        onAvailVendorCodeConditionOk (selectedRow) {
            if (selectedRow) {
                this.singleSignOnData.vendorCode = selectedRow.code;
                this.singleSignOnData.vendorName = selectedRow.description;
                this.isVendorValid = true;
            }
        },
        //LookUp Available Users
        onAvailUserCodeConditionOk (selectedRow) {
            if (selectedRow) {
                this.singleSignOnData.userId = selectedRow.code;
                this.singleSignOnData.userName = selectedRow.description;
                this.isUserValid = true;
            }
        },

        DiscardChanges() {
            this.checkExistFavorite('/app/singlesignons');
            this.$router.push({ name: 'singlesignonList' });
        },

        getSingleSignOn() {
            if (this.$attrs.editMode) {
                SingleSignOnService.get(this.$route.params.id)
                    .then(response => {
                        if (response.status == '200' && response.data) {
                            this.singleSignOnData = response.data;
                        }
                    })
                    .catch(error => {
                        this.showResponseErrorMessage(error);
                    });
            }
        },

        addSingleSignOn() {
            SingleSignOnService.add(this.singleSignOnData)
                .then(response => {
                    if (response.status == '200') {
                        this.singleSignOnData = response.data;
                        this.pendingChanges = false;
                        this.$router.push({ name: 'singlesignonList' }).catch(() => {});

                        setTimeout(
                            () =>
                                this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                                    title: this.$t('Msg.Success'),
                                    autoHideDelay: 5000,
                                    variant: 'success'
                                }),
                            50
                        );
                    }
                })
                .catch(error => {
                    elemSaveBtn.removeAttribute('disabled');
                    this.showResponseErrorMessage(error);
                });
        },

        editSingleSignOn() {
            SingleSignOnService.update(this.$route.params.id, this.singleSignOnData)
                .then(response => {
                    if (response.status == '200') {
                        this.singleSignOnData = response.data;
                        this.pendingChanges = false;

                        this.$router.push({ name: 'singlesignonList' }).catch(() => {});
                        setTimeout(
                            () =>
                                this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                                    title: this.$t('Msg.Success'),
                                    autoHideDelay: 5000,
                                    variant: 'success'
                                }),
                            50
                        );
                    }
                })
                .catch(error => {
                    elemSaveBtn.removeAttribute('disabled');
                    this.showResponseErrorMessage(error);
                });
        },

        DoAction() {
            !this.$attrs.editMode ? this.addSingleSignOn() : this.editSingleSignOn();
        },

        async validateRequired() {
            if (this.$attrs.editMode) return true;
            //validate required fields
            const vendorClean = this.singleSignOnData.vendorCode ? this.singleSignOnData.vendorCode.toString().trim() : '';
            const userClean = this.singleSignOnData.userId ? this.singleSignOnData.userId.toString().trim() : '';

            this.isVendorValid = vendorClean.length > 0;
            this.isUserValid = userClean.length > 0;

            if (!this.isVendorValid || !this.isUserValid) return false;

            const currentUserName = this.singleSignOnData.userName;
            const currentVendorName = this.singleSignOnData.vendorName;
            const response = await SingleSignOnService.existsVendorUserPair(this.singleSignOnData.vendorCode, this.singleSignOnData.userId);
            const exists = response.data;
        
            if (exists) {
                this.showMessage(
                    this.$tc('Msg.Error'),
                    `${this.$t('singleSignOns.eVendorUserCombinationExist')} (${currentVendorName} - ${currentUserName})`,
                    'error'
                );
                return false; 
            } else {
                return true;
            }
        },

        SaveOrEdit() {
            this.validateRequired().then(isValid => {
                if (isValid) {
                    this.DoAction();
                }
            });
        },

        checkUserAction() {
            if (elemSaveBtn.disabled) {
                elemSaveBtn.removeAttribute('disabled');
            }
        },

        beforeWindowUnload(e) {
            if (this.pendingChanges) {
                e.preventDefault();
                e.returnValue = '';
            }
        }
    },

    created() {
        EventBus.$on(
            'onChanged',
            function(e) {
                this.pendingChanges = e.Changed;
                this.checkUserAction();
            }.bind(this)
        );
        window.addEventListener('beforeunload', this.beforeWindowUnload);
    },

    mounted() {
        this.OptionsRightMenu.ItemsList = [];
        let layoutStatus = this.$store.state.layoutStatus;
        switch (layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            default:
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }
        this.getSingleSignOn();
        setTimeout(
            function() {
                elemSaveBtn = document.getElementById('btn_save_single_sign_on');
                elemSaveBtn.setAttribute('disabled', '');
            },
            50,
            this
        );
    },

    destroyed() {
        this.OptionsRightMenu.ItemsList = [];
        this.OptionsRightMenu.Mode = false;
        this.OptionsRightMenu.visible = false;
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
    },

    beforeDestroy() {
        window.removeEventListener('beforeunload', this.beforeWindowUnload);
    }
};
</script>
